import React from 'react'
import Benefits1 from '../../assets/images/fodc/benefits1 icon.svg'
import Benefits2 from '../../assets/images/fodc/befefits2 icon.svg'
import Benefits3 from '../../assets/images/fodc/benefits3 icon.svg'
import Benefits4 from '../../assets/images/fodc/benefits4 icon.svg'
import RightArrow from '../../assets/images/fodc/guidance_up-arrow.svg'

const Section3 = () => {
  return (
    <div className='fodc-s3 m-auto'>
        <div className='fodc-s3-wraper'>
            <p style={{opacity:'50%', marginBottom:'0'}}>Voosh //</p>
            <p className='fodc-p-text color-brand'>Befenits</p>
            <div className='row'>
                <div className='col-lg-3 col-sm-12 border-right-1'>
                    <img src={Benefits1} alt='Automatically find and appeal disputed orders' />
                    <p className='fodc-md-text pt-3'>Automatically find and appeal disputed orders</p>
                    <img src={RightArrow} alt='arrow_right_icon' />
                    <p className='fodc-sm-text pt-3'>2-6% of your revenue</p>
                </div>
                <div className='col-lg-3 col-sm-12 border-right-1 ps-25'>
                    <img src={Benefits2} alt='Automatically find and appeal disputed orders' />
                    <p className='fodc-md-text pt-3'>Instant financial reconciliation</p>
                    <img src={RightArrow} alt='arrow_right_icon' />
                    <p className='fodc-sm-text pt-3'>POS, Delivery apps, Banks, Accounting Software</p>
                </div>
                <div className='col-lg-3 col-sm-12 border-right-1 ps-25'>
                    <img src={Benefits3} alt='Automatically find and appeal disputed orders' />
                    <p className='fodc-md-text pt-3'>Automated review responses</p>
                    <img src={RightArrow} alt='arrow_right_icon' />
                    <p className='fodc-sm-text pt-3'>Doordash, Ubereats, Grubhub, Google, Yelp & more.</p>
                </div>
                <div className='col-lg-3 col-sm-12 ps-25'>
                    <img src={Benefits4} alt='Automatically find and appeal disputed orders' />
                    <p className='fodc-md-text pt-3'>Automated store downtime control</p>
                    <img src={RightArrow} alt='arrow_right_icon' />
                    <p className='fodc-sm-text pt-3'>Auto monitor & control your stores status</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Section3